var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCanada(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6042_110669)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_6042_110669)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 16,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2353 12H10.7647L10.8824 10.2703C10.8757 10.1792 10.8281 10.1552 10.6471 10.1622L8.76471 10.3784C8.76471 10.3784 9.11765 9.94595 9.11765 9.72973C9.11765 9.51351 7 8.10811 7 8.10811C7 8.10811 7.47059 8 7.58824 7.89189C7.70588 7.78378 7.11765 6.59459 7.11765 6.59459C7.11765 6.59459 8.31321 7.02703 8.41176 6.91892C8.51032 6.81081 8.64706 6.37838 8.64706 6.37838C8.64706 6.37838 9.58824 7.35135 9.82353 7.35135C10.0588 7.35135 9.35294 4.97297 9.35294 4.97297C9.35294 4.97297 9.94118 5.40541 10.1765 5.40541C10.4118 5.40541 11 4 11 4C11 4 11.5882 5.40541 11.7059 5.40541C11.8235 5.40541 12.6471 4.97297 12.6471 4.97297C12.6471 4.97297 12.0588 7.24324 12.1765 7.35135C12.2941 7.45946 13.3529 6.37838 13.3529 6.37838C13.3529 6.37838 13.4706 6.81081 13.5882 6.91892C13.7059 7.02703 14.8824 6.59459 14.8824 6.59459C14.8824 6.59459 14.2941 7.78378 14.4118 7.89189C14.5294 8 15 8.10811 15 8.10811C15 8.10811 12.8824 9.51351 12.8824 9.72973C12.8824 9.94595 13.1176 10.3784 13.1176 10.3784L11.3529 10.1622C11.2111 10.1248 11.1619 10.1532 11.1176 10.2703L11.2353 12Z",
    fill: "#F93939"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    width: 5,
    height: 16,
    fill: "#F93939"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 16,
    fill: "#F93939"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6042_110669"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_6042_110669"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 16,
    rx: 2,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCanada);
export default __webpack_public_path__ + "static/media/icon-canada.56b3a5b5bc45ce116a0a12c88581594c.svg";
export { ForwardRef as ReactComponent };